import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { LearningEffectsModule } from '@appStore/learning/effects';
import { reducers } from '@appStore/learning/reducers';
import * as fromServices from '@appStore/learning/services';

export * from '@appStore/learning/reducers';
export * from '@appStore/learning/effects';
export * from '@appStore/learning/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('learning', reducers), LearningEffectsModule],
  providers: [...fromServices.services]
})
export class LearningStoreModule {}
